import { render } from "./QaTask.vue?vue&type=template&id=6ec3d0dc&scoped=true"
import script from "./QaTask.vue?vue&type=script&lang=js"
export * from "./QaTask.vue?vue&type=script&lang=js"

import "./QaTask.vue?vue&type=style&index=0&id=6ec3d0dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec3d0dc"]])

export default __exports__